import FacturaReserva from '../../../components/posCita/FacturaReserva';
import React, { useEffect, useState } from 'react';
import { Pago } from '../../../services/pagosService'; // Asegúrate de tener este tipo
import { fetchPagosBySesion } from '../../../services/pagosService';

interface HistorialPagosModalProps {
    abierto: boolean;
    onCerrar: () => void;
    sesionId: number;
}

const HistorialPagosModal: React.FC<HistorialPagosModalProps> = ({
    abierto,
    onCerrar,
    sesionId
}) => {
    const [pagos, setPagos] = useState<Pago[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (abierto) {
            const cargarPagos = async () => {
                try {
                    const data = await fetchPagosBySesion(sesionId);
                    setPagos(data);
                } catch (error) {
                    console.error('Error al cargar pagos:', error);
                } finally {
                    setLoading(false);
                }
            };
            cargarPagos();
        }
    }, [abierto, sesionId]);

    if (!abierto) return null;

    // Puedes colocar esto al inicio del archivo
    const formatCurrency = (valor: any): string => {
        const numero = typeof valor === 'number' ? valor : parseFloat(valor);
        return `Bs ${isNaN(numero) ? '0.00' : numero.toFixed(2)}`;
    };



    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center border-b pb-4">
                        <h3 className="text-xl font-semibold text-gray-800">Historial de Pagos</h3>
                        <button onClick={onCerrar} className="text-gray-500 hover:text-gray-700">
                            &times;
                        </button>
                    </div>

                    <FacturaReserva sesionId={sesionId} />
                    {loading ? (
                        <div className="text-center py-8">
                            <p>Cargando historial...</p>
                        </div>
                    ) : pagos.length === 0 ? (
                        <div className="py-8 text-center text-gray-500">
                            No hay pagos registrados para esta sesión
                        </div>
                    ) : (
                        <div className="mt-6">
                            <div className="space-y-4">
                                {pagos.map((pago) => (
                                    <div key={pago.id} className="border border-gray-200 rounded-lg p-4">
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                                            <div>
                                                <p className="text-gray-500">Monto aplicado</p>
                                                <p className="font-medium">{formatCurrency(pago.monto)}</p>
                                                <p className="text-gray-500 mt-2">Efectivo Recibido</p>
                                                <p className="font-medium">{formatCurrency(pago.efectivo_recibido)}</p>
                                            </div>
                                            <div>
                                                <p className="text-gray-500">Cambio</p>
                                                <p className="font-medium">{formatCurrency(pago.cambio)}</p>
                                            </div>
                                            <div>
                                                <p className="text-gray-500">Fecha Pago</p>
                                                <p className="font-medium">{new Date(pago.fecha_pago).toLocaleString()}</p>
                                            </div>
                                            <div>
                                                <p className="text-gray-500">Tipo de Pago</p>
                                                <p className="font-medium">{(pago as any).tipo_pago_nombre || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistorialPagosModal;
